import { HashRouter as Router, Routes, Route } from "react-router-dom";
import './styles/styles.css';
import ScrollToTop from './components/ScrollToTop';
import { ActiveNavBarProvider } from './context/ActiveNavBarProvider';
import { Footer } from "./components/Footer";
import ContactUs from "./pages/resources/ContactUs";
import { AuthProvider } from "./context/AuthProvider";
import RequriedAuth from "./components/RequriedAuth";
import PageNotFound from "./components/PageNotFound";
import NotFound from "./components/NotFound";
import UnAuthorized from "./components/UnAuthorized";
import { DeleteProvider } from "./context/DeleteProvider";
import { AttachmentProvider } from "./context/AttachmentProvider";
import { Home } from "./pages/home/Home";
import { Navbar } from "./components/Navbar";
import { LoginIn } from "./pages/signIn/LogIn";
import { SignUp } from "./pages/signIn/SignUp";
import { LessonPage } from "./pages/Lessons/LessonPage";
import { LearnerDashboard } from "./pages/dashboard/LearnerDashboard";
import { TeacherDashboard } from "./pages/dashboard/TeacherDashboard";
import { ContributorDashboard } from "./pages/dashboard/ContributorDashboard";
import { ParentDashboard } from "./pages/dashboard/ParentDashboard";
import { SearchResult } from "./pages/search/SearchResult";
import { Settings } from "./pages/Settings/Settings";
import { ClassSettings } from "./pages/Settings/ClassSettings";
import { ClassInvitation } from "./pages/invitation/ClassInvitation";
import { EditCourse } from "./pages/Course/EditCourse";
import { VideoPage } from "./pages/Lessons/VideoPage";
import { ConfirmProvider } from "./context/ConfirmProvider";
import LessonContentPage from "./pages/Lessons/LessonContentPage";
import { AboutUs } from "./pages/aboutUs/AboutUs";
import Features from "./pages/features/Features";
import Blogs from "./pages/blogs/Blogs";
import Faq from "./pages/faq/Faq";
import WhySundaySchoolStillMatters from "./pages/blogs/WhySundaySchoolStillMatter";
import RaisingNextGenerationOfFaith from "./pages/blogs/RaisingNextGenerationOfFaith";
import EarlySpiritualEducation from "./pages/blogs/EarlySpiritualEducation";
import HeartOfSundaySchoolTeacher from "./pages/blogs/HeartOfSundaySchoolTeacher";
import StrongFamiliesAndChurches from "./pages/blogs/StrongFamiliesAndChurches";
import PowerOfGodsWord from "./pages/blogs/PowerOfGodsWord";
import StayConnectedChurch from "./pages/blogs/StayConnectedChurch";
import FellowshipWorshipGrowth from "./pages/blogs/FellowshipWorshipGrowth";
import ParentsSupportFaith from "./pages/blogs/ParentsSupportFaith";
import FutureChurch from "./pages/blogs/FutureChurch";
import YoungBelievers from "./pages/blogs/YoungBelievers";
import PrivacyPolicy from "./pages/importantLinks/PrivacyPolicy";
import TermsAndConditions from "./pages/importantLinks/TermsAndConditions";
import { ChildInvitation } from "./pages/invitation/ChildInvitation";
import HelpDocument from "./pages/helpDocument/HelpDocument";
import Docs from "./pages/helpDocument/Docs";
import { StudentProgress } from "./pages/studentProgress/StudentProgress";
import { ChildProgress } from "./pages/ChildProgess/ChildProgess";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { Users } from "./pages/admin/users/Users";
import { AddUser } from "./pages/admin/users/AddUser";
import { EditUsers } from "./pages/admin/users/EditUsers";
import { CourseCategories } from "./pages/admin/coursecategories/CourseCategories";
import { AddCourseCategory } from "./pages/admin/coursecategories/AddCourseCategory";
import { EditCourseCategory } from "./pages/admin/coursecategories/EditCourseCategory";
import { Courses } from "./pages/admin/courses/Courses";
import { AddCourse } from "./pages/admin/courses/AddCourse";
import { UpdateCourse } from "./pages/admin/courses/UpdateCourse";
import { EditCourse as EditAdminCourse } from "./pages/admin/courses/EditCourse";
import { SearchProvider } from "./context/SearchProvider";
import ForgotPassword from "./pages/signIn/ForgotPassword";

const Roles = {
  Admin: "Admin",
  Learner: "Learner",
  Teacher: "Teacher",
  Parent: "Parent",
  Contributor: "Contributor"
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <DeleteProvider>
          <ConfirmProvider>
            <ActiveNavBarProvider>
              <AttachmentProvider>
                <SearchProvider>
                  <Navbar />
                  <Routes>
                    <Route path="*" element={<NotFound />} />
                    <Route path="/not-found" element={<PageNotFound />} />
                    <Route path="/un-authorized" element={<UnAuthorized />} />

                    {/* BasicRoutes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/features" element={<Features />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blogs/why-sunday-school-still-matters" element={<WhySundaySchoolStillMatters />} />
                    <Route path="/blogs/raising-next-generation-of-faith" element={<RaisingNextGenerationOfFaith />} />
                    <Route path="/blogs/early-spiritual-education" element={<EarlySpiritualEducation />} />
                    <Route path="/blogs/heart-of-sunday-school-teacher" element={<HeartOfSundaySchoolTeacher />} />
                    <Route path="/blogs/strong-families-and-churches" element={<StrongFamiliesAndChurches />} />
                    <Route path="/blogs/power-of-gods-word" element={<PowerOfGodsWord />} />
                    <Route path="/blogs/stay-connected-church" element={<StayConnectedChurch />} />
                    <Route path="/blogs/fellowship-worship-growth" element={<FellowshipWorshipGrowth />} />
                    <Route path="/blogs/parents-support-faith" element={<ParentsSupportFaith />} />
                    <Route path="/blogs/future-church" element={<FutureChurch />} />
                    <Route path="/blogs/young-believers" element={<YoungBelievers />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="/help" element={<HelpDocument />} />
                    <Route path="/docs/:slug" element={<Docs />} />

                    <Route path="/search/result" element={<SearchResult />} />
                    <Route path="/login" element={<LoginIn />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="course-lesson" element={<LessonPage />} />
                    <Route path="/unauthorized" element={<UnAuthorized />} />
                    <Route path="/class/:invitationcode" element={<ClassInvitation />} />
                    <Route path="/child-invitation/:invitationcode" element={<ChildInvitation />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />         

                    <Route element={<RequriedAuth allowedRoles={[Roles.Admin]} />}>
                      <Route path="/admin" element={<AdminLayout />}>
                        <Route path="users" element={<Users />} />
                        <Route path="users/adduser" element={<AddUser />} />
                        <Route path="users/edituser" element={<EditUsers />} />
                        <Route path="coursecategories" element={<CourseCategories />} />
                        <Route path="coursecategories/addcategory" element={<AddCourseCategory />} />
                        <Route path="coursecategories/editcategory" element={<EditCourseCategory />} />
                        <Route path="courses" element={<Courses />} />
                        <Route path="courses/addcourse" element={<AddCourse />} />
                        <Route path="courses/updatecourse" element={<UpdateCourse />} />
                        <Route path="courses/editcourses" element={<EditAdminCourse />} />
                      </Route>
                    </Route>

                    {/* Leaner Route */}
                    <Route element={<RequriedAuth allowedRoles={[Roles.Learner]} />}>
                      <Route path="learner">
                        <Route path="dashboard" element={<LearnerDashboard />} />
                        <Route path="course-lesson" element={<LessonPage />} />
                        <Route path="videos/:id" element={<VideoPage />} />
                        <Route path="lesson-content/:id" element={<LessonContentPage />} />
                      </Route>
                    </Route>

                    {/* Teacher Route */}
                    <Route element={<RequriedAuth allowedRoles={[Roles.Teacher]} />}>
                      <Route path="teacher">
                        <Route path="dashboard" element={<TeacherDashboard />} />
                        <Route path="class/students" element={<ClassSettings />} />
                        <Route path="students/progress" element={<StudentProgress />} />
                      </Route>
                    </Route>

                    {/* Contributor Route */}
                    <Route element={<RequriedAuth allowedRoles={[Roles.Contributor]} />}>
                      <Route path="contributor">
                        <Route path="dashboard" element={<ContributorDashboard />} />
                        <Route path="edit-course" element={<EditCourse />} />
                      </Route>
                    </Route>

                    {/* Parent Route */}
                    <Route element={<RequriedAuth allowedRoles={[Roles.Parent]} />}>
                      <Route path="parent">
                        <Route path="dashboard" element={<ParentDashboard />} />
                        <Route path="childs/progress" element={<ChildProgress />} />
                      </Route>
                    </Route>

                    <Route element={<RequriedAuth allowedRoles={[Roles.Admin, Roles.Learner, Roles.Parent, Roles.Teacher, Roles.Contributor]} />}>

                      <Route path="settings" element={<Settings />} />

                    </Route>
                  </Routes>
                  <Footer />
                </SearchProvider>
              </AttachmentProvider>
            </ActiveNavBarProvider>
          </ConfirmProvider>
        </DeleteProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
